import { createSlice } from '@reduxjs/toolkit';

import { createRestSlice } from '../../utils/RestSlice';
import TaskSchedulesRepository from '../../repositories/Admin/TaskSchedulesRepository';

const taskSchedulesRestSlice = createRestSlice({
  resource: 'taskSchedule',
  repository: TaskSchedulesRepository,
  slices: ['loadTaskSchedules', 'updateTaskSchedule', 'deleteTaskSchedule'],
});

const initialState = {
  ...taskSchedulesRestSlice.initialState,
};

const taskSchedulesSlice = createSlice({
  name: 'taskSchedules',
  initialState,
  reducers: {
    ...taskSchedulesRestSlice.reducers,
  },
});
export default taskSchedulesSlice.reducer;

export const taskSchedulesRestHooks = taskSchedulesRestSlice.hooks(
  taskSchedulesSlice,
  ['admin', 'TaskSchedulesSlice']
);
